import { useSearchParams } from "react-router-dom";
import { Seo } from "@/components/Seo";
import EnrollSection from "@/components/site/EnrollSection";

export default function EnrollPage() {
  const [params] = useSearchParams();
  const course = params.get("course") || "";
  return (
    <main data-testid="page-enroll" className="pt-20">
      <Seo
        title="Enroll — Delta DL Enterprise, LLC"
        description="Apply to enroll in Delta DL Enterprise, LLC programs — Nursing Algebra, Leadership, Math Tutoring, and more."
        path="/enroll"
      />
      <EnrollSection preselect={course} />
    </main>
  );
}
